import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=367a783d&scoped=true"
import script from "./pc.vue?vue&type=script&lang=js"
export * from "./pc.vue?vue&type=script&lang=js"
import style0 from "./pc.vue?vue&type=style&index=0&id=367a783d&prod&scoped=scoped&lang=css"
import style1 from "./pc.vue?vue&type=style&index=1&id=367a783d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367a783d",
  null
  
)

export default component.exports